export default __webpack_public_path__ + "navigation-examples-custom-banner-1200-9de2d3db3a1b4e81c7f1160426602b60.png";